/* eslint-disable */
import { useRef, useEffect } from 'react';
import { requestAnimationFrame, cancelAnimationFrame } from '~/utils/animation/animationFrame';
import isAvail from '@dcode/is/avail/avail';

export const useAnimationFrame = (callback) => {
	const requestRef = useRef();
	const previousTimeRef = useRef();

	const animate = (time) => {
		if (isAvail(previousTimeRef.current)) {
			const deltaTime = time - previousTimeRef.current;
			callback(deltaTime);
		}
		previousTimeRef.current = time;
		requestRef.current = requestAnimationFrame(animate);
	};

	useEffect(() => {
		requestRef.current = requestAnimationFrame(animate);
		return () => cancelAnimationFrame(requestRef.current);
	}, []);
};

export default useAnimationFrame;
